import {VController, VModel, VLogical} from "./components";


function App() {

    return (
        <div className='container-fluid d-flex flex-column-reverse flex-md-row'>
            <div className='col-12 col-md-3'>
                <VController/>
            </div>
            <div className='col-12 col-md-9'>
                <VModel/>
            </div>
            <VLogical/>
        </div>
    )
}

export default App
